import {ReactTabulator} from "react-tabulator";
import axios from "axios";
import "./Factor.scss";
import DatePicker from "react-multi-date-picker";
import {DateObject} from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import RLookUp from "../Form/RLookUp";
import {checkForm} from "../Form";
import {SetPrintDataContext, PrintDataContext} from "../../Pages";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {useRef, useState, useEffect, useContext} from "react";
import Balance from "./Balance";
import useTitle from "../Hooks/useTitle";
import SelectProductStoreRoom from "./SelectProductStoreRoom";
import {isThereAnyNumberEmpty, isThereAnyPriceEmpty} from "./functions";
import NewTabulator from "../NewTabulator/NewTabulator";
import {formatToPersianAddComma, parseToEnRemoveComma} from "../../utils/CommaSeparator";
import {
  calculateNewDataInFactor,
  calculateSumOfEachRowInOldFactor,
  calculateSumOfTableDataInFactor
} from "./FactorFunctions";
import {
  calculateSumOfEachRowInFactor,
  deleteRowHandlerInFactor,
  sumOfTotalPricesInTable
} from "./FactorNewDetails/functions";
import tableCalc from "../../utils/tableCalc";
import _axios from "../../httpService";

export default function Factor({type}) {
  if (type === undefined) type = "buy";
  //debugger
  useTitle("فاکتور");


  const tableRef = useRef(null);
  const dataEdit = useContext(PrintDataContext);
  const [balanceStatus, setBalanceStatus] = useState(false);

  const [dataStateplz, setDataStateplz] = useState([]);
  const remainBalanceRef = useRef(null);
  const setBalanceRef = useRef(null);
  const balanceSectionRef = useRef(null);
  const salesPlatformRef = useRef(null);
  const paymentTypeRef = useRef(null);

  // useEffect(() => {
  //   let changeSomthing = () => {
  //     if (dataEdit.main !== undefined) {
  //       //debugger
  //       console.log("here is set arra!");
  //       console.log(dataStateplz);
  //       // want to  calculate sum and change type oc Count , discount...!!!
  //
  //       let countField = type === "sell" ? "na_318" : "na_319";
  //       let discountField = type === "sell" ? "na_261" : "na_264";
  //       let priceField = type === "sell" ? "na_88" : "na_89";
  //       let totalField = "total";
  //
  //       dataEdit.particle.data.map((v) => {
  //         if (v[countField] !== undefined)
  //           v[countField] = parseInt(v[countField]);
  //         if (v[discountField] !== undefined)
  //           v[discountField] = parseInt(v[discountField]);
  //         if (isNaN(v[discountField])) v[discountField] = "";
  //
  //         if (v[priceField] !== undefined)
  //           v[priceField] = parseInt(v[priceField]);
  //         if (v[totalField] !== undefined)
  //           v[totalField] = parseInt(v[totalField]);
  //
  //         if (v[countField] && v[priceField]) {
  //           v[totalField] = v[countField] * v[priceField];
  //         }
  //         if (v[discountField]) {
  //           if (v[discountField] !== 0) {
  //             v[totalField] =
  //               (v[priceField] - v[discountField]) * v[countField];
  //           }
  //         }
  //       });
  //
  //       setDataStateplz(dataEdit.particle.data);
  //       //debugger
  //     }
  //     // let data = tableRef.current.table.getData();
  //     let editedRows = tableRef?.current?.table?.getRows();
  //     for (let row of editedRows) {
  //       if (row._row.data.na_430 === "شد") {
  //         row.getElement().style.backgroundColor = "#61ae61";
  //       }
  //     }
  //     addRowHandler();
  //     doItPleaseHereAndOnChange();
  //   };
  //   axios({
  //     method: "get",
  //     url: `${localStorage.getItem(
  //       "apiUrl"
  //     )}/settings/?settingName=factorBalance`,
  //   }).then((response) => setBalanceStatus(response.data.status));
  //   setTimeout(changeSomthing, 100);
  // }, []);
  // set an empty array to table data After component changed /* this approach will solve the showing  saved data after changing component */
  useEffect(() => {
    setDataStateplz([]);
  }, [type]);

  const tableColumns = [
    {
      title: "حذف", headerSort: false, formatter: "buttonCross", // width: 60,
      style: {
        minWidth: 50 ,
        width: 50,
        maxWidth:50,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItem: 'center',
        justifyContent: 'center',
      }, justifyContent: 'center', headerHozAlign: "center",
      cellClick: function (e, cell) {

        const table = deleteRowHandlerInFactor(cell, dataStateplz)

        debugger
        // const storeIdKey = "na_707";
        // const productIdKey = "na_31";
        //
        // const productId = cell.getData()[productIdKey];
        // const storeId = cell.getData()[storeIdKey];
        // const table = [...dataStateplz]
        // table.forEach((row, index) => {
        //   if (row[productIdKey] === productId && row[storeIdKey] === storeId) {
        //     table.splice(index, 1);
        //   }
        // })
        setDataStateplz(table);
        setReload(!reload)


      },
    },
    {
      field: "primaryKey",
      visible: false,
    },
    {
      style: {
        minWidth: 50 ,
        width: 50,
        maxWidth:50,        overflow: "hidden",
      },
      title: "کد کالا",
      field: type === "sell" ? "na_31" : "na_32",
    },
    // na_707 && na_709  Almas Farahi
    {
      title: "کد انبار",
      field: type === "sell" ? "na_31" : "na_707",
      style:{
        minWidth: 60 ,
        width: 60,
        maxWidth:60 ,
      }
    },
    {
      title: "عنوان انبار",
      field: type === "sell" ? "na_31" : "na_709",
      visible: false,
    },
    {
      title: "نام کالا",
      field: type === "sell" ? "na_256" : "na_257",
      style:{
        minWidth: 200 ,
        width: 200,
        maxWidth:200,
      }
    },
    {
      title: "گروه کالا",
      field: type === "sell" ? "na_251" : "na_252",
      visible: false,
    },
    {
      title: "کد رنگ",
      field: type === "sell" ? "na_389" : "na_421",
      visible: false,
    },
    {
      title: "رنگ",
      field: type === "sell" ? "na_390" : "na_422",
    },
    {
      title: "کد سایز",
      field: type === "sell" ? "na_387" : "na_419",
      visible: false,
    },
    {
      title: "سایز",
      field: type === "sell" ? "na_388" : "na_420",
      style:{
        minWidth: 50 ,
        width: 50,
        maxWidth:50 ,
      },
    },
    {
      title: "تعداد",
      field: type === "sell" ? "na_318" : "na_319",
      editor: "number",
      formatter: tableCalc.separateNumbers,
      style:{
        minWidth: 50 ,
        width: 50,
        maxWidth:50 ,
      },


      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value)
        const newTable = calculateNewDataInFactor(dataStateplz, cell, "na_319", value)
        setDataStateplz(newTable);
        setReload(!reload);
      },


      bottomCalc: "sum",
    },
    {
      title: "فی",
      field: type === "sell" ? "na_88" : "na_89",
      editor: "number",
      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value)
        const newTable = calculateNewDataInFactor(dataStateplz, cell, "na_89", value)
        setDataStateplz(newTable);
        setReload(!reload);

      },
      formatter: tableCalc.separateNumbers

    },
    {
      title: "تخفیف",
      field: type === "sell" ? "na_261" : "na_264",
      editor: "number",
      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value)
        const newTable = calculateNewDataInFactor(dataStateplz, cell, "na_264", value)
        setDataStateplz(newTable);
        setReload(!reload);

      },
      formatter: tableCalc.separateNumbers,

      bottomCalc: "sum",
    },
    {
      title: "جمع کل",
      field: "total",
      bottomCalc: "sum",
      formatter: tableCalc.separateNumbers,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},

    },

  ];


  const tableOptions = {
    layout: "fitDataStretch",
    selectable: 1,
    index: "na_31",
  };

  function addRowHandler() {
    tableRef.current.table.on("cellEdited", function (cell) {
      //collect initial data
      let whichCellIsEditting = cell.getField();
      console.log(whichCellIsEditting);
      let tableDataPlease = dataStateplz;
      let codekalaSuffix = type === "sell" ? "na_31" : "na_32";
      let kalaCodeCellClicked = cell.getRow().getData()[codekalaSuffix];

      let countField = type === "sell" ? "na_318" : "na_319";
      let discountField = type === "sell" ? "na_261" : "na_264";
      let priceField = type === "sell" ? "na_88" : "na_89";
      let totalField = "total";
      let newValue = cell.getValue();

      if (
        whichCellIsEditting === "na_319" ||
        "na_264" ||
        "na_318" ||
        "na_261"
      ) {
        const tempArray = [];
        tableDataPlease.map((v) => {
          if (v[codekalaSuffix] === kalaCodeCellClicked) {
            // what about discountField
            if (v[discountField]) {
              if (v[discountField] !== 0) {
                v[totalField] =
                  (v[priceField] - v[discountField]) * v[countField];
              }
            } else {
              v[totalField] = v[countField] * v[priceField];
            }
          }
          tempArray.push(v);
        });

        setDataStateplz(tempArray);
      }

      doItPleaseHereAndOnChange();
    });
  }

  function sepNum(e) {
    if (e.target.value !== "") {
      let n = parseInt(e.target.value.replace(/\D/g, ""), 10);
      e.target.value = n.toLocaleString();
      if (e.target.value === "NaN") {
        e.target.value = "";
      }
    }
  }

  const [deleteRows, SetDeleteRows] = useState([]);

  function deleteRowHandler() {
    let rows = tableRef.current.table.getSelectedRows();
    let deleteSelectedRow = rows[0].getData();
    SetDeleteRows([...deleteRows, deleteSelectedRow]);
    console.log(deleteRows);
    tableRef.current.table.deselectRow();
    let remainingArr = [];
    rows.map((row) => {
      if (row.getData().na_31) {
        remainingArr = dataStateplz.filter(
          (data) => data.na_31 !== row.getData().na_31
        );
      }
      if (row.getData().na_32) {
        remainingArr = dataStateplz.filter(
          (data) => data.na_32 !== row.getData().na_32
        );
      }
      // row.delete(); no longrt need This line i useState!!
    });

    SetDeleteRows([]);
    setDataStateplz(remainingArr);
    doItPleaseHereAndOnChange();
    // fetch(`${localStorage.getItem("apiUrl")}`)
    //   .then((response) => response.json())
    //   .then((json) => {
    //     // console.log(json);
    //     setDataStateplz(remainingArr);
    //     doItPleaseHereAndOnChange();
    //   })
    //   .catch((er) => {
    //     // console.log(er)
    //     setDataStateplz(remainingArr);
    //     doItPleaseHereAndOnChange();
    //   });
    // setTimeout(doItPleaseHereAndOnChange(), 5000);
  }

  const [isShowRlookUp, setIsShowRlookUp] = useState(false);

  function toggleRlookUp(e) {
    setIsShowRlookUp(e.target.dataset.id);
  }

  const formRef = useRef(null);
  const sumRef = useRef(null);
  const sumRefCash = useRef(null);
  const sumRefBank = useRef(null);

  const taxRef = useRef(null);
  const discountRef = useRef(null);
  const serviceRef = useRef(null);

  const [rLookUpData, setRLookUpData] = useState({});

  function rlookUpCallback(data) {
    for (const name in data) {
      //debugger
      if (formRef.current[name]) {
        formRef.current[name].value = data[name];
      }
    }
  }

  useEffect(() => {
    rlookUpCallback(rLookUpData);
  });

  const rlookUpRef = useRef(null);
  const rlookUpRef2 = useRef(null);
  const [useRlookUp2, setUseRlookUp2] = useState(false);
  const [showCachAndBankFeild, setShowCachAndBankFeild] = useState(false);

  const seperateFac = useRef(null);

  useEffect(() => {
    let defaultValue = "barcode";
    searchData.type = defaultValue;

    setSearchData({...searchData});
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/product/`,
      params: {list: defaultValue},
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    })
      .then((response) => setSearchDataList(response.data))
      .catch((error) => console.error(error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [factorType, setFactorType] = useState("");
  const [searchData, setSearchData] = useState({});

  function factorTypeOnChangeHandler(e) {
    setFactorType(e.target.value);
    setRLookUpData("");
    if (e.target.value === "نقدی و حساب بانکی") {
      setShowCachAndBankFeild(true);
    } else {
      setShowCachAndBankFeild(false);
    }
    doItPleaseHereAndOnChange();
  }

  const [kalaOption, setKalaOption] = useState([]);

  function getOptionData(e) {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/product/`,
      params: {colorSize: searchData.value},
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then((response) => {
      //debugger
      setKalaOption(response.data);
      seperateFac.current.querySelector("#colorOpt").selected = "true";
    });
  }

  //     tableRef.current.table.on("cellEdited", function(cell){
  //     console.log(cell.getValue())
  // });

  const [searchDataList, setSearchDataList] = useState([]);

  function searchParamOnChangeHandler(e) {
    searchData.type = e.target.value;
    if (searchData.type === "name") {
      seperateFac.current.querySelector(".joz-options").style.display = "flex";
    } else {
      seperateFac.current.querySelector(".joz-options").style.display = "none";
    }
    setSearchData({...searchData});
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/product/`,
      params: {list: e.target.value},
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    })
      .then((response) => setSearchDataList(response.data))
      .catch((error) => console.error(error));
  }

  function addProductHandler(e) {
    // توی فاکتور خرید از این ب بعد انبار داریم
    const myStoreName = selectedStoreData.storeName;
    const myStoreId = selectedStoreData.storeId;
    if (myStoreName === "" || myStoreId === "") {
      toast.error("لطفا ابتدا یک انبار انتخاب کنید");
      return;
    }

    let data = searchData.type === "name" ? kalaOption.value : "";

    // check if color is set
    {
      //خب اگه کاربر من زده بود بر اساس نام کالا تکلیف چیه؟  سه سطر خالی میاد تو جدول
      // میخوام جلوشو بگیرم
      // searchData.type equal To barcode Or internetId Or "name"
      if (searchData.type === "name" && data === undefined) {
        toast.error("لطفا رنگ انتخاب کنید");
        return;
      }
    }

    if (searchData.value === "" || searchData.value === null) {
      toast.error("لطفا یک کالا انتخاب نمایید");
    } else {
      axios({
        method: "GET",
        url: `${localStorage.getItem("apiUrl")}/product/`,
        params: {
          detail: searchData.value,
          type: searchData.type,
          option: data,
          factorType: type,
        },
        headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
      })
        .then((res) => {
          const {
            id,
            name,
            group,
            price,
            colorId,
            color,
            sizeId,
            size,
            count,
          } = res.data;

          //debugger
          // if name null mean no data found
          if (name === null || name === undefined) {
            toast.error("داده های دریافتی معتبر نیست.");

            return;
          }
          if (count < "1" && type === "sell") {
            toast.error("این کالا در انبار موجود نیست");
          } else {
            let rowData =
              {
                primaryKey: "",
                na_32: id,
                na_257: name,
                na_252: group,
                na_421: colorId,
                na_422: color,
                na_419: sizeId,
                na_420: size,
                na_319: count,
                na_324: 1,
                na_89: price === null ? 0 : price,
                na_264: 0, // discount default 0
                na_269: 0,
                total: 0,
                na_261: 0,
                na_707: myStoreId,
                na_709: myStoreName,
              }


            // addRowHandler();
            let tableDataPlease = [...dataStateplz];

            let storeIdField = "na_707";
            let titleField = type === "sell" ? "na_31" : "na_32";
            let countField = type === "sell" ? "na_318" : "na_319";
            let discountField = type === "sell" ? "na_261" : "na_264";
            let priceField = type === "sell" ? "na_88" : "na_89";
            let totalField = "total";
            let tempDataTabulator = [];
            // let Style = [];
            // let tableRows = tableRef.current.table.getRows();
            // for (let item of tableRows) {
            //   let color = item.getElement().style.backgroundColor;
            //   let oldBarcode = item.getData().na_31;
            //   let styleObj.oldBarcode=
            //   Style.push({ oldBarcode: color });
            // }

            if (tableDataPlease?.length > 0) {
              let alreadyAdded = false;
              tableDataPlease?.map((v) => {
                if (v[titleField]) {
                  //debugger
                  if (
                    rowData[titleField] === v[titleField] &&
                    rowData[storeIdField] === v[storeIdField] // if store id is equal add it
                  ) {
                    v[countField] = parseInt(parseToEnRemoveComma(v[countField])) + 1;
                    v[totalField] = parseFloat(parseToEnRemoveComma(v[countField])) *
                      (parseFloat(parseToEnRemoveComma(v[priceField]) - v[discountField]));

                    // what about discountField
                    if (v[discountField]) {
                      if (v[discountField] !== 0) {
                        v[totalField] =
                          (v[priceField] - v[discountField]) * v[countField];
                      }
                    }
                    tempDataTabulator.push(v);
                    alreadyAdded = true;
                  } else {
                    tempDataTabulator.push(v);
                  }
                }
              });
              if (!alreadyAdded) {
                tempDataTabulator.push(rowData);
              }
            } else {
              tempDataTabulator.push(rowData);
            }

            searchData.value = "";
            setSearchData({...searchData});
            setDataStateplz(tempDataTabulator);
            setReload(!reload)


          }


        })
        .catch((error) => console.error(error));
    }
  }

  function handleKeyPress(e) {
    if (e.key === "Enter") {
      addProductHandler(e);
    }
  }

  function submitHandler(needToPrint) {
    // event.preventDefault();
    // let form = event.target;
    let form = formRef.current;
    if (checkForm([form]) && form.reportValidity()) {
      let formData = new FormData(form);
      // let tableJozData = tableRef?.current?.table?.getData();
      let tableJozData = dataStateplz;

      if (tableJozData.length === 0) {
        toast("فاکتور جز را پر کنید")
      }
      debugger
      let countArray = [];
      let codeArray = [];
      let productCount = [];
      for (let item of tableJozData) {
        let count = type === "sell" ? item["na_318"] : item["na_319"];
        countArray.push(parseInt(count));
        let code = type === "sell" ? item["na_31"] : item["na_32"];
        [...Array(item["na_319"])].map((v, index) => {
          codeArray.push(parseInt(code));
        });
        let primarykey = item["primaryKey"];
        let productItem = {};
        productItem["productId"] = code;
        productItem["amount"] = count;
        productItem["factorId"] = "";
        dataEdit.main !== undefined
          ? (productItem["factorId"] = primarykey)
          : (productItem["factorId"] = "");

        productCount.push(productItem);
      }

      let formDataObject = {};
      // dataEdit.main !== undefined
      //   ? (formDataObject = {primaryKey: dataEdit.main.primaryKey})
      //   : (formDataObject = {primaryKey: ""});

      formDataObject = dataEdit.main === undefined ? {primaryKey: ""} : {primaryKey: dataEdit.main.primaryKey}

      formData.forEach(function (value, key) {
        formDataObject[key] = value;
        console.log(formData);
        console.log("key:" + key + "     " + "value:" + value);

        if (key === "na_205" || key === "na_204") {
          formDataObject[key] = parseFloat(value.replace(/[^a-z0-9-]/g, ""));
        }

        // new section 2023_April_09
        if (key === "na_226" || key === "na_489") {
          formDataObject[key] = value;
        }
      });
      // i wanna do some thing here
      if (useRlookUp2 === true) {
        //فرم ها رو چک کنم
        if (sumRefBank.current.value === "") {
          sumRefBank.current.className += " border border-danger";
          toast.error("لطفا مبلغ واریزی به حساب بانکی را وارد کنید. ");
          return;
        }
        if (sumRefBank.current.value === "0") {
          // sumRefBank.current.className +=" border border-danger";
          toast.error(
            " مبلغ واریزی به حساب بانکی صفر قابل قبول نیست. نوع واریز را بررسی کنید. "
          );
          return;
        }

        if (sumRefCash.current.value <= 0) {
          if (sumRefCash.current.value === 0) {
            toast.error(
              "مبلغ پرداخت نقدی نمیتواند صفر باشد. لطفا مجددا بررسی کنید. "
            );
          }
          if (sumRefCash.current.value < 0) {
            toast.error(
              "مبلغ نقدی نمیتواند کمتر از صفر باشد. لطفا مجددا بررسی کنید. "
            );
          }
          toast.warn("لطفا مورد را بررسی نمایید ");
          return;
        }

        if (sumRefCash.current.value <= 0) {
          toast.error(
            "مبلغ واریزی به کارت بیشتر از مبلغ کل می باشد! لطفا مجددا بررسی کنید! "
          );
          return;
        }

        //پایان چک کردن فرم

        if (type === "sell") {
          formDataObject["na_426"] = sumRefCash.current.value.replaceAll(
            ",",
            ""
          );
          formDataObject["na_427"] = sumRefBank.current.value.replaceAll(
            ",",
            ""
          );
        } else {
          //  i mean  else if type==="buy"
          formDataObject["na_428"] = sumRefCash.current.value.replaceAll(
            ",",
            ""
          );
          formDataObject["na_429"] = sumRefBank.current.value.replaceAll(
            ",",
            ""
          );
        }
      }

      // formData.forEach((value, key) => (
      //   if(key="na_205"){formDataObject[key]=value}
      //   else
      //   {formDataObject[key] = value}));
      if (dataStateplz.length !== 0) {
        let data = {
          entities: [
            {
              entity: type === "sell" ? "FAKKOLSELL" : "FAKKOLBUE",
              data: [formDataObject],
            },
            {
              entity: type === "sell" ? "FAKJOZSELL" : "FAKLOZBUE",
              data: dataStateplz,
            },
          ],
        };

        if (isThereAnyPriceEmpty(data)) {
          toast.error("فی نمیتواند خالی باشد");
          return;
        }
        if (isThereAnyNumberEmpty(data)) {
          toast.error("تعداد نمیتواند خالی باشد");
          return;
        }
        axios({
          method: "POST",
          url: `${localStorage.getItem("apiUrl")}/product/`,
          data: {amountCheck: productCount},
          headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
        })
          .then((response) => {
            if (response.data.status === true || type !== "sell") {
              toast.info("در حال ثبت فاکتور");
              let tempKprint;
              // needToPrint === 1 ? (tempKprint = true) : (tempKprint = false);
              tempKprint = needToPrint === 1

              axios({
                method: "POST",
                url: `${localStorage.getItem("apiUrl")}/frm_submit/`,
                data: {data: data, kprint: tempKprint},
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              })
                //   _axios.post("/frm_submit/")
                .then((data) => {
                  console.log(response.data);
                  data = data.data;
                  if (data.status === true) {
                    toast.success(data.message);
                    const factorForm = formRef.current;
                    const formFields = factorForm.querySelectorAll("input");
                    for (let field of formFields) {
                      if (
                        field.type === "button" ||
                        field.type === "submit" ||
                        field.name === "na_72" ||
                        field.parentElement.className ===
                        "rlookup-field-container"
                      ) {
                        formRef.current.querySelector(
                          ".btn-outline-dark"
                        ).style.border = "1px solid #212529";
                        formRef.current.querySelector(
                          ".btn-outline-dark"
                        ).style.color = "#212529";
                      } else {
                        // Hold city and Province Value
                        if (
                          field.getAttribute("name") !== "na_423" &&
                          field.getAttribute("name") !== "na_424"
                        ) {
                          field.value = "";
                        }
                      }
                    }
                    // tableRef.current.table.clearData();
                    setDataStateplz([])
                    doItPleaseHereAndOnChange();
                    if (useRlookUp2 === true) {
                      sumRefBank.current.value = "";
                      sumRefCash.current.value = "";
                    }
                    //debugger
                    if (dataEdit.main !== undefined && needToPrint !== 1) {
                      // navigate(-1);
                      navigate("/list/234-s", {
                        state: {idb: dataEdit.main.primaryKey},
                      });
                    }
                    if (needToPrint === 1) {
                      if (type === "sell") {
                        data.invoiceData.type = "billPrintFromTable";
                        setprint(data.invoiceData);
                        navigate("/factorprint");
                      } else {
                        // اینجا باید درخواست بزنم بک بگم آقای بک من بهت کل کد کالاها رو میدم تو به من
                        // یه آرایه ای از آبجکت ها بده که توی اون مشخصات بارکد ها نوشته شده باشه
                        //  بعدش من همه ی اون اطلاعات رو مپ بزنم نشون کاربرم بدم
                        // barcodeData = GiveMeBarcodeData(codeArray);


                        const codeArrays = []
                        countArray.forEach((v, index) => {
                          const id = codeArray[index]
                          for (let i = 0; i < countArray[index]; i++) {
                            codeArrays.push(id)
                          }
                        })
                        const CodesArrayFormData = new FormData();
                        CodesArrayFormData.append("id", `[${codeArrays}]`);
                        CodesArrayFormData.append("type", "id");
                        const temp = axios({
                          method: "post",
                          url: `${localStorage.getItem("apiUrl")}/barcode/`,
                          // params: {id: temp, type: typeToSendBack},
                          data: CodesArrayFormData,
                          headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                              "token"
                            )}`,
                          },
                        })
                          .then((response) => {
                            console.log(response.data);
                            if (response.data.length > 0) {
                              response.data.map((v, i) => {
                                v.barcodeCountUserInput = countArray[i];
                              });

                              response.data.type = "barcodePrintFromBuyBill";
                              const sendData = {
                                type: response.data.type,
                                data: response.data,
                              };
                              setprint(sendData);
                              navigate("/factorprint");
                            }
                          })
                          .catch((error) => {
                            console.log(error);
                          });

                        toast.promise(temp, {
                          pending: "در حال دریافت بارکدها... لطفا صبر کنید.",
                          success: "بارکدها جهت چاپ آماده هستند.",
                          error: "دریافت بارکد با خطا رو به رو شد.",
                        });
                      }
                    }
                  }
                })
                .catch((error) => {
                  console.log(error);
                  toast.error("ثبت فاکتور با مشکل مواجه شد");
                });

              // toast.promise(factorSubmitRequest, {
              //   pending: "در حال ثبت فاکتور",
              //   success: "ثبت فاکتور با موفقیت انجام شد",
              //   error: "ثبت فاکتور با مشکل مواجه شد",
              // });
            } else {
              toast.error(`موجودی کالای ${response.data.errors} کافی نیست`);
            }
          })
          .catch((error) => {
            toast.error("نتیجه ای دریافت نشد.");
          });
      } else {
        toast.error("لطفا فاکتور جزِء را پر کنید");
      }
    } else {
      if (paymentTypeRef.current.value === "") {
        toast.error("لطفا نوع پرداختی را انتخاب نمایید.");
        return;
      }

      if (
        formRef.current.querySelector(".rlookup-field-container input")
          .value === ""
      ) {
        formRef.current.querySelector(".btn-outline-dark").style.border =
          "1px solid red";
        formRef.current.querySelector(".btn-outline-dark").style.color = "red";
      }

      toast.error("لطفا فیلد های ضروری را پر نمایید");
    }
  }

  const dateCal = useRef(null);

  let [date, setDate] = useState(new DateObject());

  const setprint = useContext(SetPrintDataContext);

  let navigate = useNavigate();

  // const [printData,setPrintData]=useState();
  useEffect(() => {
    if (type === "sell") {
      axios({
        method: "Get",
        url: `${localStorage.getItem("apiUrl")}/settings/`,
        params: {settingName: "cityProvince"},
        headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
      }).then((response) => {
        if (response.data.status) {
          formRef.current.querySelector('[name="na_423"]').value =
            response.data.data.province;
          formRef.current.querySelector("[name=na_424]").value =
            response.data.data.city;
        }
      });
    }
  }, []);

  function sellType(e) {
    if (e.target.value === "سایت") {
      formRef.current.querySelector('[name="na_425"]').style.display = "block";
      formRef.current
        .querySelector('[name="na_425"]')
        .setAttribute("required", "");
    } else {
      formRef.current.querySelector('[name="na_425"]').style.display = "none";
      formRef.current
        .querySelector('[name="na_425"]')
        .removeAttribute("required");
    }
  }

  function keyOpenRlookUp(e) {
    if (e.target.value === "Tab") {
      toggleRlookUp();
    }
  }

  // if(dataEdit.main !== undefined && tableRef.current.table !== undefined){
  //   setprint("")
  //   }

  function restoreEditData(form, data) {
    // setFactorType("واریز به حساب بانکی")
    // static set factor type

    if (type === "sell") {
      setFactorType(data.na_349);
    } else {
      setFactorType(data.na_353);
    }

    for (const key in data) {
      if (form[key] !== undefined) {
        form[key].value = data[key];
        const TempCompare = type === "sell" ? "na_72" : "na_71";
        if (key === TempCompare) {
          setDate(data[key]);
        }
      }
    }
  }

  useEffect(() => {

    setTimeout(() => {

      if (dataEdit.particle !== undefined) {
        setDataStateplz(dataEdit.particle.data);
        setReload(!reload)
      }

    }, 1000)
  }, [])
  useEffect(() => {
    return () => {
      setprint(1);
    };
  }, []);
  useEffect(() => {
    if (dataEdit.main && formRef) {
      restoreEditData(formRef.current, dataEdit.main);
      rlookUpCallback();
    }
  }, [factorType]);

  const doItPleaseHereAndOnChange = (input) => {
    if (input !== undefined) sepNum(input);
    let sum = sumOfTotalPricesInTable(dataStateplz);


    let taxVal =
      taxRef.current.value === "" ? 0 : parseInt(taxRef.current.value) * 0.01;
    let taxService =
      serviceRef.current.value === ""
        ? 0
        : parseInt(
          parseFloat(serviceRef.current.value.replace(/[^a-z0-9-]/g, ""))
        );
    let discountVal =
      discountRef.current.value === ""
        ? 0
        : parseInt(discountRef.current.value.replace(/[^a-z0-9-]/g, ""));
    let totalSum = sum + taxService - discountVal;
    let taxSum = totalSum * taxVal;
    totalSum = totalSum + taxSum;
    sumRef.current.innerHTML = totalSum.toLocaleString();

    if (sumRefCash.current !== null) {
      if (sumRefBank.current !== null) {
        // sumRefBank.current.value=parseInt(parseFloat((sumRefBank.current.value).replace(/[^a-z0-9-]/g, '')));
        if (parseFloat(parseToEnRemoveComma(sumRefBank.current.value)) < 0) {
          sumRefBank.current.value = 0;
        }
        // sumRefCash.current.value = +(sumRef.current.innerHTML) - +(sumRefBank.current.value)
        sumRefCash.current.value = formatToPersianAddComma(
          +totalSum -
          +(parseInt(
            parseFloat(
              // sumRefBank.current.value.replace(/[^a-z0-9-]/g, "")
              parseFloat(parseToEnRemoveComma(sumRefBank.current.value))
            )
          ) > 0
            ? parseInt(
              parseFloat(
                // sumRefBank.current.value.replace(/[^a-z0-9-]/g, "")
                parseFloat(parseToEnRemoveComma(sumRefBank.current.value))
              )
            )
            : 0)
        );
      }
    }
  };

  useEffect(() => {
    // console.log("Here i am wanna close calender on Tab Key");
    dateCal.current.addEventListener("keydown", function (event) {
      if (event.keyCode === 9) {
        dateCal.current.closeCalendar();
      }
    });
  }, [dateCal]);
  const [barcodeCount, setBarcodeCount] = useState([]);

  const checkedCodeHandler = (enteredBarcode) => {
    enteredBarcode = parseInt(enteredBarcode);
    if (enteredBarcode !== undefined) {
      console.log(enteredBarcode);
      let rows = tableRef.current.table.getRows();
      let primaryArray = [];
      let tableData = dataStateplz;
      for (let i of tableData) {
        primaryArray.push(i["na_31"]);
      }
      if (!primaryArray.includes(enteredBarcode)) {
        toast.error("این کالا در فاکتور نیست");
      } else {
        for (let row of rows) {
          let data = row.getData();
          let isExist = barcodeCount.map((v) => v["code"]);
          if (enteredBarcode === data["na_31"]) {
            if (barcodeCount.length > 0 && data["na_318"] > 1) {
              balanceSectionRef.current.style.display = "block";
              for (let item of barcodeCount) {
                let sumCount = item.count;

                if (sumCount + 1 === data["na_318"]) {
                  setBalanceRef.current.innerHTML = data["na_318"];
                  remainBalanceRef.current.innerHTML = 0;
                  row.getElement().style.backgroundColor = "#61ae61";
                  tableRef.current.table.updateOrAddData([
                    {na_31: data["na_31"], na_430: ""},
                    {na_31: data["na_31"], na_430: "شد"},
                  ]);
                } else if (item.code === enteredBarcode) {
                  setBarcodeCount(
                    barcodeCount.map((item) => {
                      if (item.code === enteredBarcode) {
                        item.count = item.count + 1;
                        return item;
                      } else {
                        return item;
                      }
                    })
                  );
                  setBalanceRef.current.innerHTML = sumCount + 1;
                  remainBalanceRef.current.innerHTML =
                    data["na_318"] - (sumCount + 1);
                  break;
                } else {
                  if (isExist.includes(enteredBarcode) === false) {
                    let x = {code: enteredBarcode, count: 1};
                    setBarcodeCount((prevState) => [...prevState, x]);
                    setBalanceRef.current.innerHTML = 1;
                    remainBalanceRef.current.innerHTML = data["na_318"] - 1;
                    break;
                  }
                }
              }
            } else if (barcodeCount.length === 0 && data["na_318"] > 1) {
              balanceSectionRef.current.style.display = "block";
              let x = {code: enteredBarcode, count: 1};
              setBarcodeCount((prevState) => [...prevState, x]);
              setBalanceRef.current.innerHTML = 1;
              remainBalanceRef.current.innerHTML = data["na_318"] - 1;
            } else {
              balanceSectionRef.current.style.display = "none";
              row.getElement().style.backgroundColor = "#61ae61";
              tableRef.current.table.updateOrAddData([
                {na_31: data["na_31"], na_430: ""},
                {na_31: data["na_31"], na_430: "شد"},
              ]);
            }
          }
        }
      }
    }
  };

  // they Tell me "Add Store" So i Add this state To manage it and then Add it to  table
  const [selectedStoreData, setSelectedStoreData] = useState({
    storeId: "",
    storeName: "",
  });
  const selectedStore = (storeId, storeName) => {
    setSelectedStoreData({storeId, storeName});
  };

  const [reload, setReload] = useState(false);
  useEffect(() => {


    const textLog = "Just Reload Called";
    console.log("%c" + textLog, 'color:blue;border:2px solid red');
    const tableData = [...dataStateplz];
    const newTableData = calculateSumOfEachRowInOldFactor(tableData);
    setDataStateplz(newTableData);
    doItPleaseHereAndOnChange()

  }, [reload])


  return (
    <>
      <div className="factor-component">
        {isShowRlookUp && (
          <RLookUp
            // id={rlookUpRef.current.dataset.id}
            id={
              useRlookUp2 === true
                ? rlookUpRef2.current.dataset.id
                : rlookUpRef.current.dataset.id
            }
            callBackDataHandler={(data) => setRLookUpData(data)}
            modalHandler={[isShowRlookUp, setIsShowRlookUp]}
          />
        )}
        <div className="total">
          <h5 className="factor-title">{`فاکتور ${
            type === "sell" ? "فروش" : "خرید"
          } کل`}</h5>
          <form
            ref={formRef}
            onSubmit={(event) => {
              event.preventDefault();
              submitHandler(0);
            }}
            autoComplete={"off"}
          >
            {type === "buy" && (
              <input
                className="form-control"
                name="na_290"
                placeholder="شماره فاکتور"
                required
              />
            )}

            <div className="form-control">
              <DatePicker
                ref={dateCal}
                calendar={persian}
                className="form-control"
                placeholder="تاریخ"
                name={type === "sell" ? "na_72" : "na_71"}
                locale={persian_fa}
                value={date}
                calendarPosition="bottom-right"
                hideOnScroll
              />
            </div>

            {type === "sell" && (
              <select
                name="na_351"
                className="form-select"
                defaultValue={"فاکتور"}
                required
              >
                <option hidden value="">
                  نوع فاکتور
                </option>
                <option value="فاکتور">فاکتور</option>
                <option value="پیش فاکتور">پیش فاکتور</option>
              </select>
            )}
            <select
              name={type === "sell" ? "na_349" : "na_353"}
              className="form-select"
              onChange={factorTypeOnChangeHandler}
              ref={paymentTypeRef}
              defaultValue={""}
              required
            >
              <option value="" hidden>
                نوع پرداخت
              </option>
              <option
                value={type === "sell" ? "دریافت وجه نقد" : "پرداخت از صندوق"}
              >
                نقدی
              </option>
              <option
                value={
                  type === "sell"
                    ? "واریز به حساب بانکی"
                    : "پرداخت از حساب بانکی"
                }
              >
                واریز به حساب بانکی
              </option>

              <option value="حساب دفتری">حساب دفتری</option>

              <option
                value={
                  type === "sell" ? "نقدی و حساب بانکی" : "نقدی و حساب بانکی"
                }
              >
                نقدی و حساب بانکی
              </option>
            </select>
            {(factorType === "نقدی و حساب بانکی" ||
              factorType === "نقدی و حساب بانکی") && (
              <>
                <input
                  type="button"
                  data-id={type === "sell" ? "27" : "23"}
                  onClick={(event) => {
                    setUseRlookUp2(false);
                    toggleRlookUp(event);
                  }}
                  onFocus={(event) => {
                    setUseRlookUp2(false);
                    toggleRlookUp(event);
                  }}
                  className="btn btn-outline-dark"
                  value="انتخاب صندوق"
                  required
                  ref={rlookUpRef}
                />
                <div className="rlookup-field-container">
                  <input
                    name={type === "sell" ? "na_227" : "na_226"}
                    required
                    readOnly
                  />
                </div>

                <div className="rlookup-field-container2">
                  <input
                    name={type === "sell" ? "na_227" : "na_489"}
                    required
                    readOnly
                  />
                </div>
                <input
                  type="button"
                  required
                  data-id={type === "sell" ? "26" : "22"}
                  className="btn btn-outline-dark"
                  onClick={(event) => {
                    setUseRlookUp2(true);
                    toggleRlookUp(event);
                  }}
                  onFocus={(event) => {
                    setUseRlookUp2(true);
                    toggleRlookUp(event);
                  }}
                  value="انتخاب حساب"
                  ref={rlookUpRef2}
                />
                <div className="rlookup-field-container">
                  <input
                    name={type === "sell" ? "na_23" : "na_22"}
                    required
                    readOnly
                  />
                  <input
                    name={type === "sell" ? "na_243" : "na_242"}
                    required
                    readOnly
                  />
                  <input
                    name={type === "sell" ? "na_298" : "na_297"}
                    required
                    readOnly
                  />
                </div>
              </>
            )}
            {(factorType === "دریافت وجه نقد" ||
              factorType === "پرداخت از صندوق") && (
              <>
                <input
                  type="button"
                  data-id={type === "sell" ? "27" : "23"}
                  onClick={(event) => {
                    setUseRlookUp2(false);
                    toggleRlookUp(event);
                  }}
                  onFocus={(event) => {
                    setUseRlookUp2(false);
                    toggleRlookUp(event);
                  }}
                  className="btn btn-outline-dark"
                  value="انتخاب صندوق"
                  required
                  ref={rlookUpRef}
                />
                <div className="rlookup-field-container">
                  <input
                    name={type === "sell" ? "na_227" : "na_226"}
                    required
                    readOnly
                  />
                  <div className="rlookup-field-container2">
                    <input
                      name={type === "sell" ? "na_227" : "na_489"}
                      required
                      readOnly
                    />
                  </div>
                </div>
              </>
            )}
            {(factorType === "واریز به حساب بانکی" ||
              factorType === "پرداخت از حساب بانکی") && (
              <>
                <input
                  type="button"
                  required
                  data-id={type === "sell" ? "26" : "22"}
                  className="btn btn-outline-dark"
                  onClick={(event) => {
                    setUseRlookUp2(false);
                    toggleRlookUp(event);
                  }}
                  onFocus={(event) => {
                    setUseRlookUp2(false);
                    toggleRlookUp(event);
                  }}
                  value="انتخاب حساب"
                  ref={rlookUpRef}
                />
                <div className="rlookup-field-container">
                  <input
                    name={type === "sell" ? "na_23" : "na_22"}
                    required
                    readOnly
                  />
                  <input
                    name={type === "sell" ? "na_243" : "na_242"}
                    required
                    readOnly
                  />
                  <input
                    name={type === "sell" ? "na_298" : "na_297"}
                    required
                    readOnly
                  />
                </div>
              </>
            )}
            {factorType === "حساب دفتری" && (
              <>
                <input
                  type="button"
                  data-id={type === "sell" ? "25" : "21"}
                  className="btn btn-outline-dark"
                  onClick={(event) => {
                    setUseRlookUp2(false);
                    toggleRlookUp(event);
                  }}
                  onFocus={(event) => {
                    setUseRlookUp2(false);
                    toggleRlookUp(event);
                  }}
                  value={type === "sell" ? " انتخاب مشتری" : " انتخاب فروشنده "}
                  ref={rlookUpRef}
                />
                <div className="rlookup-field-container">
                  <input
                    name={type === "sell" ? "na_41" : "na_53"}
                    required
                    readOnly
                  />
                  <input
                    name={type === "sell" ? "na_217" : "na_231"}
                    required
                    readOnly
                  />
                </div>
              </>
            )}

            {type === "sell" && (
              <>
                <select
                  name="na_383"
                  required
                  className="form-select"
                  onChange={sellType}
                  ref={salesPlatformRef}
                  defaultValue={""}
                >
                  <option value="" hidden>
                    بستر فروش
                  </option>
                  <option value="اینستا">اینستاگرام</option>
                  <option value="واتس آپ">واتس اپ</option>
                  <option value="سایت">وبسایت</option>
                  <option value="حضوری">حضوری</option>
                </select>
                <input
                  type="text"
                  className="form-control"
                  placeholder="کد سفارش"
                  name="na_425"
                />
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control mx-1"
                    placeholder="استان"
                    name="na_423"
                    required
                  />
                  <input
                    type="text"
                    className="form-control mx-1"
                    placeholder="شهر"
                    name="na_424"
                    required
                  />
                </div>
              </>
            )}

            <input
              type="text"
              className="form-control"
              placeholder="عنوان خدمات"
              name={type === "sell" ? "na_266" : "na_265"}
            />
            <input
              type="text"
              className="form-control"
              placeholder="مبلغ خدمات"
              ref={serviceRef}
              // value={serviceValue}

              name={type === "sell" ? "na_205" : "na_204"}
              onChange={(input) => {
                doItPleaseHereAndOnChange(input);
              }}
            />

            <div className="input-group">
              <input
                type="text"
                className="form-control mx-1"
                placeholder="درصد مالیات"
                ref={taxRef}
                name={type === "sell" ? "na_162" : "na_161"}
                onChange={doItPleaseHereAndOnChange}
              />
              <input
                type="text"
                className="form-control mx-1"
                placeholder="تخفیف"
                ref={discountRef}
                name={type === "sell" ? "na_263" : "na_262"}
                onChange={(e) => {
                  //مبلغ تخفیف نباید از مبلغ خود فاکتور بیشتر شود.
                  //debugger
                  let totalValue = sumRef.current.innerHTML;
                  totalValue =
                    totalValue === undefined || totalValue === ""
                      ? 0
                      : totalValue;
                  if (parseInt(e.target.value) > totalValue) {
                    toast.error("مبلغ تخفیف نباید از مبلغ کل خرید بیشتر باشد!");
                    e.target.value = "";
                    return;
                  }
                  doItPleaseHereAndOnChange(e);
                }}
              />
            </div>
            {/* <input
            type="number"
            className="form-control"
            placeholder="تعداد"
            name="number"
          /> */}
            <input type="submit" className="submit-btn" value="ثبت فاکتور"/>
          </form>
          {type !== "buy" && (
            <button
              className="print-btn btn-outline-primary"
              // onClick={submitAndPrint}
              onClick={(event) => {
                event.preventDefault();
                submitHandler(1);
              }}
            >
              <i className="fas fa-print mr-2"></i>ثبت و پرینت
            </button>
          )}
          {type === "buy" && (
            <button
              className="print-btn btn-outline-primary"
              onClick={(event) => {
                event.preventDefault();
                submitHandler(1);
              }}
            >
              <i className="fas fa-print mr-2"></i>ثبت و چاپ بارکد
            </button>
          )}
        </div>
        <div className="total">
          <h5 className="factor-title">{`فاکتور ${
            type === "sell" ? "فروش" : "خرید"
          } جزء`}</h5>
          <div className="seperate-factor" ref={seperateFac}>
            <div className="search-object">
              <SelectProductStoreRoom title={'انبار'} selectedStore={selectedStore}/>
              <select
                className="form-select"
                onChange={searchParamOnChangeHandler}
                defaultValue="barcode"
              >
                <option value="internetId">بر اساس کد کالای اینترنتی</option>
                <option value="name">بر اساس نام کالا</option>
                <option value="barcode">بر اساس بارکد</option>
              </select>
              <input
                type="search"
                className="form-control"
                placeholder="جستجو"
                name="search"
                onKeyUp={handleKeyPress}
                list="factorPageProductList"
                autoComplete="off"
                value={searchData.value}
                onChange={(e) => {
                  searchData.value = e.target.value;
                  setSearchData({...searchData});
                  getOptionData(e);
                }}
              />
              <datalist id="factorPageProductList">
                {searchDataList.map((value, index) => (
                  <option key={index} value={value}/>
                ))}
              </datalist>
              <button
                className="btn btnCustom btnSubmit"
                onClick={addProductHandler}
              >
                +
              </button>
            </div>
            <div className="joz-options">
              <select
                name="na_351"
                placeholder="رنگ"
                className="form-select"
                required
                onChange={(e) => {
                  kalaOption.value = e.target.value;
                }}
              >
                <option id="colorOpt" defaultValue hidden>
                  رنگ
                </option>
                {kalaOption.map((value) => (
                  <option value={value.color + "---" + value.size}>
                    {value.color + " " + value.size}
                  </option>
                ))}
              </select>
            </div>
            {/* if(dataEdit.main !== undefined && tableRef.current.table){
      addRowHandler(dataEdit.particle.data);
     } */}

            <NewTabulator
              columns={tableColumns}
              data={dataStateplz}
              style={{height: "50vh", overflow: 'scroll'}}
              className={"header__color__F1F1F1"}


            />
            {/*<ReactTabulator*/}
            {/*  ref={tableRef}*/}
            {/*  columns={tableColumns}*/}
            {/*  // data={dataEdit.main !== undefined ? dataEdit.particle.data : [] }*/}

            {/*  data={dataStateplz}*/}
            {/*  dataChanged={(newData) => console.log("dataChanged", newData)}*/}
            {/*  options={tableOptions}*/}
            {/*  style={{ height: "50vh" }}*/}
            {/*/>*/}
            <div className={"d-flex align-items-center"}>
              {showCachAndBankFeild && (
                <>
                  <div className="sum-label"> نقدی :</div>
                  <input
                    className="form-control  w-25 mx-2"
                    ref={sumRefCash}
                    disabled
                  />
                  <div className="sum-label"> حساب بانکی :</div>
                  <input
                    type={"text"}
                    className=" form-control w-25 mx-2"
                    onKeyUp={(event) => {
                      let bankPrice = parseToEnRemoveComma(event.target.value)
                      //debugger
                      if (
                        +bankPrice >
                        +sumRef.current.innerText.replaceAll(",", "")
                      ) {
                        toast.error(
                          "مبلغ حساب بانکی نمیتواند از مبلغ کل بیشتر باشد."
                        );
                        event.target.value = "";
                        return;
                      } else {
                        event.target.value = formatToPersianAddComma(bankPrice);
                        doItPleaseHereAndOnChange()

                      }
                    }}
                    ref={sumRefBank}
                  />
                </>
              )}

              <div className="sum-parent">
                <div className="sum-label">مبلغ کل:</div>
                <div className="sum-inputs" ref={sumRef}></div>
              </div>
            </div>


            <div className="d-flex align-items-center showRemainBalance">
              {(dataStateplz?.main?.na_349 === "" || balanceStatus) &&
                type === "sell" && (
                  <Balance
                    onEditMode={dataEdit.main !== undefined ? "" : ""}
                    onCheckBarcode={checkedCodeHandler}
                  />
                )}
              <div className="balanceSection" ref={balanceSectionRef}>
                <div>
                  <span>تراز شده :</span> <span ref={setBalanceRef}></span>
                </div>
                <div>
                  <span>تراز نشده :</span> <span ref={remainBalanceRef}></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
